import { GetDailyWordStatsRequest, GetLast30DaysStatsRequest, UserDailyWordsInfo, UserWordDayStat } from '../dto/user-words';
import { httpArg, httpGet, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/daily-words')
export abstract class IDailyWordTrackingService {
	@httpGet('get-daily-stats')
	getDailyStats(
		@httpArg('request') request: GetDailyWordStatsRequest,
		@httpUserId() userId?: string
	): Promise<UserDailyWordsInfo> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	@httpGet('get-last-30-days-stats')
	getLast30DaysStats(
		@httpArg('request') request: GetLast30DaysStatsRequest,
		@httpUserId() userId?: string
	): Promise<UserWordDayStat[]> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}
}

